import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getBillingHistory } from "../service";
import { PAGE_SIZE } from "utils/constants";

export const useBillingHistory = () => {
  const {
    data,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["billingHistory"],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        size: PAGE_SIZE,
      };

      const response = await getBillingHistory(params);

      return {
        data: response.data,
        currentPage: pageParam,
        totalPages: response.total_pages,
        totalCount: response.total_count,
      };
    },
    getNextPageParam: (lastPage) => {
      return lastPage.currentPage < lastPage.totalPages
        ? lastPage.currentPage + 1
        : undefined;
    },
  });

  const billingHistory = data?.pages?.flatMap((page) => page.data) || [];
  const latestPage = data?.pages?.[data?.pages.length - 1];
  const totalPages = latestPage?.totalPages || 0;
  const totalCount = latestPage?.totalCount || 0;
  const currentPage = latestPage?.currentPage || 1;

  return {
    isLoading,
    isFetchingNextPage,
    billingHistory,
    totalPages,
    totalCount,
    currentPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  };
};
